<template>
  <div class="chat">
    <!-- ssdscx
    {{ formParamSRSt }} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content" style=" overflow-wrap: break-word;">
                <div class="chat-img-group clearfix"
                  v-if="formParamSRSt.header.message_type == 'image'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamSRSt.header.image_url" />
                  </a>
                </div>
                <ul class="attach-list"
                  v-if="formParamSRSt.header.message_type == 'document'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamSRSt.header.image_url" target="_blank">File</a>
                  </li>
                </ul>
                <p v-html="$util.formatMessage(formParamSRSt.header.message)" v-if="formParamSRSt.header.message != ''"
                  v-linkified></p>


              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    formParamSRSt: {
      type: Object,
      default: () => ({
        header: {
          copy: false,
          id: "",
          license_id: "",
          message: "",
          image_url: "",
          is_enable_attach_file: false,
          is_custom_url: false,
          message_type: "text",
        },
      })
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {
    // formParamSRSt() {
    //   return this.$store.state.birthdayGreetings.formParamSRSt;
    // }
  },
  methods: {
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "preview-bdgreetings"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/preview.vue